<template>
  <el-dialog :title="title" :visible="visible" width="680px" :before-close="handleClose">
    <div class="good_dialog">
      <div class="good_img">
        <ISwiper :imgList="facilitiesData.imgList"></ISwiper>
      </div>
      <div class="good_title">
        {{ isShow ? facilitiesData.title : facilitiesData.name }}
      </div>
      <div class="mobile">
        <img src="../../../assets/img/facilities/dh.png" />
        <span>{{ facilitiesData.tel }}</span>
        <img src="../../../assets/img/facilities/mail.png" style="margin-left: 30px" />
        <span>{{ facilitiesData.email }}</span>
      </div>
      <div class="good_html" v-html="facilitiesData.content" v-if="isShow"></div>
      <div class="good_detail" v-else>
        <div class="conference_entitle">
          <div class="conference_img">
            <img src="../../../assets/img/facilities/pm.png" />
            <span>{{ facilitiesData.areaNum }}m²</span>
          </div>
          <div class="conference_img">
            <img src="../../../assets/img/facilities/rn.png" />
            <span>{{ facilitiesData.userNum }}人</span>
          </div>
          <div class="conference_img" v-for="val in corollary" :key="val.value" v-show="facilitiesData[val.value] == 1">
            <img :src="val.img" />
            <span>{{ val.chName }}</span>
          </div>
        </div>
        <div class="service_desc">
          <div class="service_desc_top" v-for="item in facilitiesData.hotelServiceDesc" :key="item.titleCh">
            <div class="desc_item" v-if="item.show">
              <div class="desc_left">
                <span>·{{ item.titleCh }}</span>
                <span style="margin-left: 10px">{{ item.titleEn }}</span>
              </div>
              <div class="desc_right">
                <span>{{ item.descCh }}</span>
                <span style="margin-left: 10px">{{ item.descEn }}</span>
              </div>
            </div>
          </div>
          <div class="service_desc_top">
            <div class="desc_item">
              <div class="desc_left">
                <span>其他说明</span>
                <span style="margin-left: 10px">Description</span>
              </div>
              <div class="desc_right">
                <span>{{ facilitiesData.summary }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ISwiper from "./ISwiper.vue";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    facilitiesData: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      corollary: [
        {
          chName: "WIFI",
          enName: "",
          value: "hasWifi",
          checked: 0,
          img: require("@/assets/img/facilities/wifi.png"),
        },
        {
          chName: "电视",
          enName: "Television",
          value: "hasTv",
          checked: 0,
          img: require("@/assets/img/facilities/ds.png"),
        },
        {
          chName: "LED屏",
          enName: "LED",
          value: "hasLed",
          checked: 0,
          img: require("@/assets/img/facilities/led.png"),
        },
        {
          chName: "投影仪",
          enName: "Projectors",
          value: "hasHdr",
          checked: 0,
          img: require("@/assets/img/facilities/tyx.png"),
        },
        {
          chName: "麦克风",
          enName: "Microphones",
          value: "hasMic",
          checked: 0,
          img: require("@/assets/img/facilities/mkf.png"),
        },
      ],
    };
  },
  components: { ISwiper },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.good_img {
  width: 640px;
  height: auto;
}
.good_title {
  margin: 30px 0 28px 0;
  font-size: 16px;

  font-weight: bold;
  color: #333333;
}
.good_html {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #333333;
}
.mobile {
  display: flex;
  align-items: center;
  margin-bottom: 39px;
  img {
    width: 21px;
    height: 21px;
    padding-right: 20px;
  }
  span {
    font-size: 14px;

    font-weight: 400;
    color: #333333;
  }
}
.conference_entitle {
  display: flex;
  flex-wrap: wrap;
  line-height: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid #f0f0f0;
  .conference_img {
    display: flex;
    align-items: center;
    margin-right: 40px;
    width: 100px;
    img {
      width: 22px;
      height: auto;
      margin-right: 20px;
    }
    span {
      font-size: 14px;

      font-weight: 400;
      color: #333333;
    }
  }
}
.service_desc {
  margin: 30px 0;
  .service_desc_top {
    .desc_item {
      margin-bottom: 24px;
      display: flex;
      .desc_left {
        width: 220px;
        display: flex;
      }
      .desc_right {
        margin-left: 60px;
        line-height: 18px;
        span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
}
</style>
